import { render } from "./AutoSlot.vue?vue&type=template&id=320c7f24"
import script from "./AutoSlot.vue?vue&type=script&lang=js"
export * from "./AutoSlot.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/AutoSlot.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "320c7f24"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('320c7f24', __exports__)) {
    console.log('reload')
    api.reload('320c7f24', __exports__)
  }
  
  module.hot.accept("./AutoSlot.vue?vue&type=template&id=320c7f24", () => {
    console.log('re-render')
    api.rerender('320c7f24', render)
  })

}


export default __exports__